package pl.michal_cyran.brand_hub.pages.utils

import androidx.compose.runtime.Composable
import pl.michal_cyran.brand_hub.components.sections.DarkBackgroundSection
import pl.michal_cyran.brand_hub.components.sections.LightBackgroundSection

@Composable
fun PageContent(
    vararg composables: @Composable () -> Unit
) {
    composables.forEachIndexed { i, composable ->
        if (i % 2 == 0) {
            DarkBackgroundSection {
                composable()
            }
        } else {
            LightBackgroundSection {
                composable()
            }
        }
    }
}